import Navbar from "./navBar";
import SectionOne from "./AboutComponents/sectionOne";
import "../css/TeeStyles.css";
import SectionSix from "./sectionSix";
import { ReactElement } from "react";
import SectionTwo from "./ServicesComponents/sectionTwo";

const Services: React.FC = (): ReactElement => {
  return (
    <>
      <Navbar />
      <main>
        <SectionOne content="Services" />
        <SectionTwo />
        <SectionSix />
      </main>
    </>
  );
};
export default Services;
